/*
 * Action Types
 */
export enum PlantasTypes {
  LIST_SEATMAPS_REQUEST = '@plantas/LIST_SEATMAPS_REQUEST',
  LIST_SEATMAPS_SUCCESS = '@plantas/LIST_SEATMAPS_SUCCESS',
  LIST_SEATMAPS_FAILURE = '@plantas/LIST_SEATMAPS_FAILURE',

  GET_SEATMAP_REQUEST = '@plantas/GET_SEATMAP_REQUEST',
  GET_SEATMAP_SUCCESS = '@plantas/GET_SEATMAP_SUCCESS',
  GET_SEATMAP_FAILURE = '@plantas/GET_SEATMAP_FAILURE',

  CREATE_SEATMAP_REQUEST = '@plantas/CREATE_SEATMAP_REQUEST',
  CREATE_SEATMAP_SUCCESS = '@plantas/CREATE_SEATMAP_SUCCESS',
  CREATE_SEATMAP_FAILURE = '@plantas/CREATE_SEATMAP_FAILURE',

  UPDATE_SEATMAP_REQUEST = '@plantas/UPDATE_SEATMAP_REQUEST',
  UPDATE_SEATMAP_SUCCESS = '@plantas/UPDATE_SEATMAP_SUCCESS',
  UPDATE_SEATMAP_FAILURE = '@plantas/UPDATE_SEATMAP_FAILURE',

  DELETE_SEATMAP_REQUEST = '@plantas/DELETE_SEATMAP_REQUEST',
  DELETE_SEATMAP_SUCCESS = '@plantas/DELETE_SEATMAP_SUCCESS',
  DELETE_SEATMAP_FAILURE = '@plantas/DELETE_SEATMAP_FAILURE',

  CLEAR_SEATMAP_DATA = '@plantas/CLEAR_SEATMAP_DATA',
}

/*
 * Data types
 */
export interface SeatmapSeatInterface {
  id: string;
  seatmapId: string;
  floor: number;
  seatNumber: number;
  seatType: number;
  enabled: boolean;
  position: number | null;
  profileId: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface SeatmapCarInterface {
  id: string;
  license: string;
  prefix: string;
}

export interface SeatmapInterface {
  id: string;
  name: string;
  floors: number;
  status: number;
  seatNumbering: number | null;
  transportOperatorId: string;
  createdAt: string;
  updatedAt: string;
  seats: SeatmapSeatInterface[];
  appliedVehicles: number;
  Cars: SeatmapCarInterface[];
}

/*
 * State type
 */
export interface PlantasState {
  readonly seatmapsList: SeatmapInterface[];
  readonly seatmapData: SeatmapInterface | null;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
